import { apiUrl } from '../config/api'

function authHeaders() {
  const secret = typeof localStorage !== 'undefined' ? localStorage.getItem('x-auth-secret') : null
  const h = { 'Accept': 'application/json', 'Content-Type': 'application/json' }
  if (secret) h['x-auth-secret'] = secret
  return h
}

export async function listServices() {
  const res = await fetch(apiUrl('/api/admin/services'), {
    headers: authHeaders(),
    credentials: 'include',
  })
  if (!res.ok) throw new Error(await res.text())
  return res.json()
}

export async function createService(payload) {
  const res = await fetch(apiUrl('/api/admin/services'), {
    method: 'POST',
    headers: authHeaders(),
    credentials: 'include',
    body: JSON.stringify(payload),
  })
  if (!res.ok) throw new Error(await res.text())
  return res.json()
}

export async function updateService(id, payload) {
  const res = await fetch(apiUrl(`/api/admin/services/${id}`), {
    method: 'PUT',
    headers: authHeaders(),
    credentials: 'include',
    body: JSON.stringify(payload),
  })
  if (!res.ok) throw new Error(await res.text())
  return res.json()
}

export async function deleteService(id) {
  const res = await fetch(apiUrl(`/api/admin/services/${id}`), {
    method: 'DELETE',
    headers: authHeaders(),
    credentials: 'include',
  })
  if (!res.ok) throw new Error(await res.text())
}

export async function listServiceLocationMaps(deliveryLocationId) {
  const params = deliveryLocationId != null ? `?deliveryLocationId=${deliveryLocationId}` : ''
  const res = await fetch(apiUrl(`/api/admin/services/location-maps${params}`), {
    headers: authHeaders(),
    credentials: 'include',
  })
  if (!res.ok) throw new Error(await res.text())
  return res.json()
}

export async function createServiceLocationMap(payload) {
  const res = await fetch(apiUrl('/api/admin/services/location-maps'), {
    method: 'POST',
    headers: authHeaders(),
    credentials: 'include',
    body: JSON.stringify(payload),
  })
  if (!res.ok) throw new Error(await res.text())
  return res.json()
}

export async function updateServiceLocationMap(id, payload) {
  const res = await fetch(apiUrl(`/api/admin/services/location-maps/${id}`), {
    method: 'PUT',
    headers: authHeaders(),
    credentials: 'include',
    body: JSON.stringify(payload),
  })
  if (!res.ok) throw new Error(await res.text())
  return res.json()
}

export async function deleteServiceLocationMap(id) {
  const res = await fetch(apiUrl(`/api/admin/services/location-maps/${id}`), {
    method: 'DELETE',
    headers: authHeaders(),
    credentials: 'include',
  })
  if (!res.ok) throw new Error(await res.text())
}
